import { casaApiUrl } from "configs/casa-api";

import { fetch } from "../utils/fetch";

function logRenderedUrl(url, businessUnitId, tenantId) {
  return fetch(`${casaApiUrl}/test-helper/echo-all-params`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ url, businessUnitId, tenantId }),
  }).then((response) => {
    if (response.status === 200) {
      return response.json();
    } else {
      return Promise.reject("pos log-url failed");
    }
  });
}

export default {
  logRenderedUrl,
};



// WEBPACK FOOTER //
// ./src/services/pos-service.js